import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function TableShimmer({ columns = [], rowCount = 5 }) {
    return (
        <>
            {Array(rowCount).fill().map((_, rowIndex) => (
                <tr key={rowIndex} className="border border-[#DEDEDE] h-14">
                    {columns.map((col, colIndex) => (
                        <td
                            key={colIndex}
                            className={`px-4 py-3 text-[16px] leading-normal font-medium ${
                                col.center ? 'text-center' : ''
                            }`}
                            style={{
                                minWidth: col.minWidth,
                                maxWidth: col.maxWidth,
                            }}
                        >
                            <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
                                <Skeleton
                                    count={1}
                                    className="h-[30px]"
                                    width={col.minWidth || col.maxWidth || '100px'}
                                />
                            </SkeletonTheme>
                        </td>
                    ))}
                </tr>
            ))}
        </>
    );
}
